export default __webpack_public_path__ + "images/cb1853ab2ffcb5a2f5b3ab2d2c4478a1-chevron-down-pink.svg";